import type { AdminUser } from '../../types/admin';
import {
  AuthTokenBundle,
  clearAuthTokenBundle,
  getAccessToken,
  saveAuthTokenBundle,
} from './authTokens';

const ADMIN_AUTH_TOKEN_KEY = 'shiftwagon_admin_auth_token';
const ADMIN_AUTH_USER_KEY = 'shiftwagon_admin_auth_user';

export function saveAdminAuthToken(token: string): void {
  saveAuthTokenBundle('admin', { accessToken: token });
}

export function getAdminAuthToken(): string | null {
  return getAccessToken('admin');
}

export function saveAdminAuthTokens(bundle: AuthTokenBundle): void {
  saveAuthTokenBundle('admin', bundle);
}

export function clearAdminAuthToken(): void {
  clearAuthTokenBundle('admin');
  sessionStorage.removeItem(ADMIN_AUTH_TOKEN_KEY);
}

export function saveAdminAuthUser(user: AdminUser): void {
  sessionStorage.setItem(ADMIN_AUTH_USER_KEY, JSON.stringify(user));
}

export function getAdminAuthUser(): AdminUser | null {
  const raw = sessionStorage.getItem(ADMIN_AUTH_USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

export function clearAdminAuthUser(): void {
  sessionStorage.removeItem(ADMIN_AUTH_USER_KEY);
}

export function clearAdminAuthFlow(): void {
  clearAdminAuthToken();
  clearAdminAuthUser();
}
